import {
  FETCH_PRODUCTS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_PHOTO,
  CREATE_PRODUCT,
  DELETE_PRODUCT
} from "../../store/constants/hwk";

export function fetchProducts() {
  return {
    type: FETCH_PRODUCTS
  };
}

export function updateProduct(payload = {}) {
  return {
    type: UPDATE_PRODUCT,
    payload
  };
}

export function updateProductPhoto(payload = {}) {
  return {
    type: UPDATE_PRODUCT_PHOTO,
    payload
  };
}

export function createProduct(payload = {}) {
  return {
    type: CREATE_PRODUCT,
    payload
  };
}

export function deleteProduct(id = null) {
  return {
    type: DELETE_PRODUCT,
    id
  };
}
